import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AssignmentStatusMessageTypes } from '../../store/constants';
import { Store, select } from '@ngrx/store';
import { State } from '../../store/state';
import {
    getAssignmentStatusCodeMessage$,
    getAssignmentStatusCodeMessageType$,
    getAssignmentStatusCode$,
    getSurveyName$,
} from '../../store/selectors';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-claim-cme-ce-notification-box',
    templateUrl: './claim-cme-ce-notification-box.component.html',
    styleUrls: ['./claim-cme-ce-notification-box.component.css'],
})
export class ClaimCmeCeNotificationBoxComponent implements OnInit {
    readonly ASSIGNEMTN_STATUS_MESSAGE_TYPES = AssignmentStatusMessageTypes;

    message$: Observable<string>;
    messageType$: Observable<AssignmentStatusMessageTypes>;

    assignmentStatusCode$: Observable<string>;

    surveyName$: Observable<string>;

    constructor(private store: Store<State>) {}

    ngOnInit() {
        this.message$ = this.store.pipe(select(getAssignmentStatusCodeMessage$));
        this.messageType$ = this.store.pipe(select(getAssignmentStatusCodeMessageType$));

        this.assignmentStatusCode$ = this.store.pipe(select(getAssignmentStatusCode$));

        this.surveyName$ = this.store.pipe(select(getSurveyName$));
    }

    get titleCaseSurveyName(): Observable<string> {
        return this.surveyName$.pipe(
            map((surveyName) => {
                if (surveyName) {
                    return surveyName[0].toUpperCase() + surveyName.slice(1);
                } else {
                    return surveyName;
                }
            })
        );
    }
}
